module.exports = __webpack_public_path__ + "img/sia_909l_detail_rsh.d2c73545.jpg";